<ch-loader [loading]="isInitialLoading"></ch-loader>
<div [ngStyle]="{ display: isInitialLoading ? 'none' : 'block' }">
  <ch-breadcrumb [parts]="['Pages', editMode ? pageName : 'Add New']"></ch-breadcrumb>
  <form (ngSubmit)="edit(form)" #form="ngForm">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12 col-md-12">
          <div class="card mb-4">
            <div class="card-header">Form</div>
            <div class="card-body">
              <div class="form-group">
                <label for="page-edit-header">Header</label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="pageData.header"
                  name="header"
                  #header="ngModel"
                  class="form-control"
                  id="page-edit-header"
                  required
                  [readonly]="loading"
                />
                <small class="text-danger" *ngIf="(header.touched || header.dirty) && !header.valid"> Header is invalid. </small>
              </div>
              <div class="form-group">
                <label for="page-edit-title">Name</label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="pageData.name"
                  name="title"
                  #title="ngModel"
                  class="form-control"
                  id="page-edit-title"
                  required
                  [readonly]="loading"
                />
                <small class="text-danger" *ngIf="(title.touched || title.dirty) && !title.valid"> Title is invalid. </small>
              </div>
              <div class="form-group">
                <label for="page-edit-description">Description</label>

                <div *ngIf="!isInitialLoading"><ch-wysiwyg [value]="initialContent" (onChange)="contentChange($event)"></ch-wysiwyg></div>

                <!-- <small class="text-danger" *ngIf="(description.touched || description.dirty) && !description.valid"> -->
                <small class="text-danger" *ngIf="!isInitialLoading && !pageData.content"> Description is invalid. </small>
              </div>

              <div style="margin-top: 40px;">
                <button id='pageEditDelete' *ngIf="editMode" type="button" class="btn btn-danger" (click)="delete()" [disabled]="loading">Delete</button>
                <span class="btn-right">
                  <button id='pageEditCancel' type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="loading">Cancel</button>
                  <button id='pageEditSave' type="submit" class="btn btn-primary" [disabled]="loading">Save</button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/pages/page-edit/page-edit.component.html